import { render, staticRenderFns } from "./IconMessage.vue?vue&type=template&id=fcc3e7d2&scoped=true&"
import script from "./IconMessage.vue?vue&type=script&lang=js&"
export * from "./IconMessage.vue?vue&type=script&lang=js&"
import style0 from "./IconMessage.vue?vue&type=style&index=0&id=fcc3e7d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc3e7d2",
  null
  
)

export default component.exports